module.exports = __webpack_public_path__ + "img/suoding.08e90923.png";